import globals from '../../../../scripts/modules/globals';
import parameters from '../../../../scripts/modules/parameters';

const listing = ( ext = parameters.getWindow() ) => {
	let per_page = 200;
	let segments = window.location.href.split('/');
	let availability = segments[segments.length-2];
	let query = `availability=${availability}&per_page=${per_page}${ext}`;
	return `${globals.url}/wp-json/custom/v1/properties?${query}`;
}

const single = ( id ) => {
	return `${globals.url}/wp-json/custom/v1/property/${id}`;
}

export default {
	listing,
	single
}
